/**
 * @file Explicit lucide icon map for command-catalog entries. Registry stores an
 * icon NAME (string); we resolve it to a component here. Explicit map (not
 * `import *`) keeps tree-shaking intact. Falls back to the Command icon.
 */
import {
  Telescope,
  RefreshCw,
  Users,
  Crown,
  CalendarDays,
  MessageSquare,
  LayoutGrid,
  Type,
  ShieldCheck,
  GitPullRequest,
  ClipboardCheck,
  Mail,
  Megaphone,
  Workflow,
  Cpu,
  Command,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

const MAP: Record<string, LucideIcon> = {
  Telescope,
  RefreshCw,
  Users,
  Crown,
  CalendarDays,
  MessageSquare,
  LayoutGrid,
  Type,
  ShieldCheck,
  GitPullRequest,
  ClipboardCheck,
  Mail,
  Megaphone,
  Workflow,
  Cpu,
  Command,
};

export function cmdIcon(name: string | null | undefined): LucideIcon {
  return (name && MAP[name]) || Command;
}
